// Lens taxonomy constants — values must match the strings stored in orgs.json exactly
export const SCALE_LEVELS = [
  { value: 'Local', label: 'Local' },
  { value: 'Regional', label: 'Regional' },
  { value: 'National', label: 'National' },
  { value: 'Supranational (EU-wide)', label: 'Supranational' },
  { value: 'International', label: 'International' },
];

// Convert "N - Some Label" → {value: raw, label: "N. Some label"}
export const lensOpts = (raws) => raws.map(v => {
  const m = v.match(/^(\d+)\s*-\s*(.+)$/);
  const n = m?.[1] || '';
  const rest = (m?.[2] || v).trim();
  return { value: v, label: `${n}. ${rest}` };
});

export const POLICY_LEVELS = lensOpts([
  '1 - Policy Distant',
  '2 - Occasional Campaigner',
  '3 - Policy Contributor',
  '4 - Policy Partner',
  '5 - Policy Actor',
]);

export const IMPLEMENTATION_LEVELS = lensOpts([
  '1 - Thinking and Advocating',
  '2 - Indirect Enabling',
  '3 - Testing and Piloting',
  '4 - Direct Enabling',
  '5 - On the Ground Operator',
]);

export const POWER_LEVELS = lensOpts([
  '1 - Building Power from the Ground Up',
  '2 - Amplifying Grassroots Voices',
  '3 - Bridging Between Movements and Institutions',
  '4 - Engaging Decision-Makers from the Outside',
  '5 - Operating Within Power Structures',
]);

export const STAKEHOLDER_TYPES = [
  'Local Communities',
  'Activists and Social Movements',
  'Youth and Student Movements',
  'Artists and Cultural Institutions',
  'Researchers / Academics',
  'Funders / Philanthropic Organizations',
  'Social Enterprises',
  'Small Businesses',
  'Corporations',
  'Labour Groups and Trade Unions',
  'Elected Officials',
  'Civil Servants',
  'Media / Communicators',
  'International Organisations NGOs & Networks',
  'Faith-Based Organisations',
  'Financial Institutions',
  'Other',
];

// Non/profit categorization — these are Baserow's ACTUAL multi-select options,
// which are pre-combined "legal status, org type" pairs (not atomic types).
// The submit form + validator must offer exactly these so submissions match.
// (The directory type filter derives its options from the data, not this list.)
// If Baserow defines more options than the 12 below, add them here.
export const ORG_TYPES = [
  'Non-profit, Association',
  'Non-profit, Chapter/Affiliate',
  'Non-profit, Charity/Philanthropy',
  'Non-profit, Foundation',
  'Non-profit, Other',
  'Non-profit, Public Sector Entity',
  'Non-profit, University',
  'Not-for-profit, Cooperative',
  'Not-for-profit, Other',
  'Not-for-profit, Social Enterprise',
  'Unincorporated, Chapter/Affiliate',
  'Unincorporated, Network/Coalition',
];
